import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import Assignee, { toUser, fromUser } from '../Assignee'
import AssigneeRemoveButton from '../AssigneeRemoveButton'
import AssigneeAddButton from '../AssigneeAddButton'
import sortBy from 'lodash/sortBy'
import differenceWith from 'lodash/differenceWith'
import intersectionWith from 'lodash/intersectionWith'

const isNotEqualTo = (assignment) => {
  return (otherAssignment) => assignment.userId !== otherAssignment.userId
}

/**
 * @augments{ PureComponent<any, any> }
 */
class AssigneePanel extends PureComponent {

  constructor(props) {
    super(props)
    this.state = {
      assignmentsAdding: [],
      assignmentsRemoving: []
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState(prevState => ({
      assignmentsAdding: differenceWith(
        prevState.assignmentsAdding,
        nextProps.task.assignments,
        (addingAssignment, assignment) => assignment.userId === addingAssignment.userId
      ),
      assignmentsRemoving: intersectionWith(
        prevState.assignmentsRemoving,
        nextProps.task.assignments,
        (removingAssignment, assignment) => assignment.userId === removingAssignment.userId
      )
    }))
  }

  getCurrentAssignments = () => {
    return ([ ...this.props.task.assignments, ...this.state.assignmentsAdding ])
      .filter(assignment => this.state.assignmentsRemoving.every(isNotEqualTo(assignment)))
  }

  addTaskAssignment = (user) => {
    const assignment = fromUser(user)
    this.props.saveTaskAssignments(
      [ ...this.getCurrentAssignments(), assignment ],
      this.onAddAssignmentFailure(assignment)
    )
    this.setState(prevState => ({
      assignmentsAdding: [ ...prevState.assignmentsAdding, assignment ]
    }))
  }

  onAddAssignmentFailure = (failedAssignment) => {
    return () => this.setState(prevState => ({
      assignmentsAdding: prevState.assignmentsAdding.filter(isNotEqualTo(failedAssignment))
    }))
  }

  removeTaskAssignment = (assignment) => {
    let newAssignments = this.getCurrentAssignments().filter(isNotEqualTo(assignment))
    this.props.saveTaskAssignments(newAssignments, this.onRemoveAssignmentFailure(assignment))
    this.setState(prevState => ({
      assignmentsRemoving: [ ...prevState.assignmentsRemoving, assignment ]
    }))
  }

  onRemoveAssignmentFailure = (failedAssignment) => {
    return () => this.setState(prevState => ({
      assignmentsRemoving: prevState.assignmentsRemoving.filter(isNotEqualTo(failedAssignment))
    }))
  }

  render() {
    let { localize } = this.props

    return (
      <div className='task-modal__assignees'>
        <div className='task-modal__field'>{localize('tasks.Label_Assignees')}</div>
        <div className='task-modal__value--multiline'>
          {
            sortBy(this.getCurrentAssignments(), [
              assignment => assignment.firstName.toLowerCase(),
              assignment => assignment.lastName.toLowerCase()
            ])
            .map(assignment => (
              this.props.task.actions.edit ? (
                <AssigneeRemoveButton
                  key={assignment.userId}
                  assignment={assignment}
                  removeTaskAssignment={this.removeTaskAssignment} />
              ) : (
                <Assignee key={assignment.userId} assignment={assignment} />
              )
            ))
          }
          { this.props.task.actions.edit &&
            <AssigneeAddButton
              currentAssignments={this.getCurrentAssignments().map(toUser)}
              onSelect={this.addTaskAssignment} />
          }
        </div>
      </div>
    )
  }
}

AssigneePanel.propTypes = {
  localize: PropTypes.func,
  task: PropTypes.object,
  saveTaskAssignments: PropTypes.func.isRequired
}

export default AssigneePanel



// WEBPACK FOOTER //
// ./src/components/TaskDetails/AssigneePanel.js